import { Link } from 'react-router-dom'
import { ChevronLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="container mx-auto px-4 py-16 max-w-4xl">
        <Link to="/" className="mb-8 block">
          <Button variant="outline" size="sm" className="gap-2">
            <ChevronLeft className="w-4 h-4" />Retour au site
          </Button>
        </Link>

        <div className="border-l-4 border-primary pl-6 mb-12">
          <p className="text-primary text-sm uppercase tracking-widest mb-2">Informations légales</p>
          <h1 className="text-4xl font-bold font-heading">Mentions légales & Politique de confidentialité</h1>
        </div>

        <div className="space-y-10 text-muted-foreground leading-relaxed">
          {/* Éditeur */}
          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4 border-l-4 border-primary pl-4">Éditeur du site</h2>
            <p className="text-sm text-muted-foreground whitespace-pre-line pl-3">
              BENSOULA SIDI — SIRET : 904 665 908 00011{'\n'}
              Paris — Sidi.bensoula@gmail.com
            </p>
          </section>

          {/* Objet */}
          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4 border-l-4 border-primary pl-4">Objet</h2>
            <p>Ce site présente les activités de Sidi Bensoula, formateur en coiffure masculine et barber, et les formations proposées par l'Académie Sidi Bensoula.</p>
          </section>

          {/* Propriété intellectuelle */}
          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4 border-l-4 border-primary pl-4">Propriété intellectuelle</h2>
            <p>L'ensemble des contenus (textes, images, vidéos) présents sur ce site sont protégés par le droit d'auteur. Toute reproduction sans autorisation est interdite.</p>
          </section>

          {/* Données personnelles */}
          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4 border-l-4 border-primary pl-4">Données personnelles</h2>
            <p className="mb-3">Conformément au RGPD et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification et de suppression de vos données.</p>
            <p>Contact : <a href="mailto:sidi.bensoula@gmail.com" className="text-primary hover:underline">sidi.bensoula@gmail.com</a></p>
          </section>

          {/* Cookies */}
          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4 border-l-4 border-primary pl-4">Cookies</h2>
            <p>Ce site utilise des cookies techniques essentiels à son bon fonctionnement. Vous pouvez paramétrer vos préférences via la bannière de consentement.</p>
          </section>

          {/* Hébergement */}
          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4 border-l-4 border-primary pl-4">Hébergement</h2>
            <p>Ce site est hébergé par Skywork AI, 1600 Amphitheatre Parkway, Mountain View, CA 94043, États-Unis.</p>
          </section>

          {/* Politique confidentialité */}
          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4 border-l-4 border-primary pl-4">Politique de confidentialité</h2>
            <p className="mb-3">Les informations recueillies via les formulaires de contact sont utilisées uniquement pour répondre à vos demandes et ne sont jamais cédées à des tiers.</p>
            <p>Vous pouvez exercer vos droits en envoyant un email à : <a href="mailto:sidi.bensoula@gmail.com" className="text-primary hover:underline">sidi.bensoula@gmail.com</a></p>
          </section>

          <p className="text-xs text-muted-foreground/60 pt-6 border-t border-border">© 2026 Sidi Bensoula. Tous droits réservés.</p>
        </div>
      </div>
    </div>
  )
}
